/*=========================================================================================
	File Name: sidebarItems.js
	Description: Sidebar Items list. Add / Remove menu items from here.
	Strucutre:
					url     => router path
					name    => name to display in sidebar
					slug    => router path name
					icon    => Feather Icon component/icon name
					tag     => text to display on badge
					tagColor  => class to apply on badge element
					i18n    => Internationalization
					submenu   => submenu of current item (current item will become dropdown )
								NOTE: Submenu don't have any icon(you can add icon if u want to display)
					isDisabled  => disable sidebar item/group
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [

	{
		url: "/",
		name: 'Dashboard',
		tagColor: 'warning',
		icon: 'HomeIcon',
		i18n: 'Dashboard',

	},
	{
		url: null,
		name: 'Customer',
		tagColor: 'warning',
		icon: 'UserIcon',
		i18n: 'Customer',
		submenu: [
			{
				url: '/customer-list',
				name: 'CustomerList',
				slug: 'CustomerList',
				i18n: 'CustomerList'
			},

		]
	},

	{
		url: null,
		name: 'StoreHouse',
		tagColor: 'warning',
		icon: 'ArchiveIcon',
		i18n: 'StoreHouse',
		submenu: [
			{
				url: '/storehouse-list',
				name: 'StoreHouse',
				slug: 'StoreHouse',
				i18n: 'StoreHouse'
			},

		]
	},
	{
		url: null,
		name: 'Stock',
		tag: '2',
		tagColor: 'warning',
		icon: 'ListIcon',
		i18n: 'Stock',
		submenu: [
			{
				url: '/stock-list',
				name: 'StockList',
				slug: 'StockList',
				i18n: 'StockList'
			},

		]
	},
	{
		url: null,
		name: 'Order',
		tag: '2',
		tagColor: 'warning',
		icon: 'ShoppingBagIcon',
		i18n: 'Order',
		submenu: [
			{
				url: '/order-list',
				name: 'OrderList',
				slug: 'OrderList',
				i18n: 'OrderList'
			},

		]
	},
	{
		url: null,
		name: 'StockTracking',
		tag: '2',
		tagColor: 'warning',
		icon: 'TruckIcon',
		i18n: 'StockTracking',
		submenu: [
			{
				url: '/stock-tracking',
				name: 'StockTrackingList',
				slug: 'StockTrackingList',
				i18n: 'StockTrackingList'
			},
			{
				url: '/stock-tracking-addnew',
				name: 'StockTracking',
				slug: 'StockTracking',
				i18n: 'StockTracking'
			},
		]
	}

]

